export const FETCH = '@action/FETCH';
export const DISPLAY_PROVIDERS = '@action/DISPLAY_PROVIDERS';
export const HIDE_PROVIDERS = '@action/HIDE_PROVIDERS';
export const LOAD_MORE = '@action/LOAD_MORE';
export const NEW_SEARCH = '@action/NEW_SEARCH';
